import React from "react"
import ContactForm from "@components/contact-form"
import Heading from "@components/heading"

const ContactFormBlock = ({ id, title }) => {
  return (
    <div
      className="px-4 w-full pt-12 bg-cream sm:px-6 lg:pt-16 lg:px-8 lg:pt-8 bg-sage rounded-xl"
      id={id ? id : 'contact-form'}
    >
      <Heading className="mb-0 text-center font-owners-text">
        {title || "Have a question?"}
      </Heading>
      <ContactForm />
    </div>
  )
}

export default ContactFormBlock
